import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import store from './redux/store';
import { I18nextProvider } from 'react-i18next';
import i18n from './translations/i18n';
import I18nGate from './translations/I18nGate';
import { RouterProvider } from 'react-router-dom';
import './assets/css/App.css';
import { router } from './routes/router.tsx';
import { AuthProvider } from "./contexts/AuthContext";
import ResponsiveHandler from "./hooks/ResponsiveHandler";
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            gcTime: 10 * 60 * 1000,
            refetchOnWindowFocus: false,
        },
    },
});

export default function App() {
    return (
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <I18nextProvider i18n={i18n}>
                        <I18nGate>
                            <ResponsiveHandler/>
                            <RouterProvider
                                router={router}/>
                        </I18nGate>
                    </I18nextProvider>
                </AuthProvider>
            </QueryClientProvider>
        </Provider>
    );
};
